import React, { useContext, useEffect, useState } from "react";
import { Container } from "../components/utils";
import { PhrasesContext } from "../context/phrasesContext";
import { getPrivacyPolicy } from "../services/Common";
import ThemeLayout from "../layouts/ThemeLayout";
const PrivacyPolicy = () => {
  const [lang, setLang] = useState("");
  const [privacy, setPrivacy] = useState("");

  const [enPhrase, arPhrase] = useContext(PhrasesContext);



  const getPrivacyPolices = (currentLang) => {
    return getPrivacyPolicy(currentLang).then((res) => {
      setPrivacy(res);
    });
  };

  useEffect(() => {
    const lang = window.localStorage.getItem("lang");
    let currentLang = lang;
    if (lang === "en") {
      document.body.dir = "ltr";
      setLang("en");
      currentLang = "en";
    } else {
      document.body.dir = "rtl";
      setLang("ar");
      currentLang = "ar";
    }
    getPrivacyPolices(currentLang);
  }, []);

 

  const sanitizedHtml = privacy.replace(/className/g, "class");

  return (
    <ThemeLayout>
      <Container>     
         <div className="flex flex-col items-center justify-center my-5">
              <h3 className="text-2xl lg:text-3xl text-gray-600 leading-snug font-semibold">
                {lang === "en"
                  ? enPhrase["lbl_privacy_policy"]
                  : arPhrase["lbl_privacy_policy"]}
              </h3>
            </div>
        <div className="text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: sanitizedHtml }}></div>
      </Container>
    </ThemeLayout>
  );
};

export default PrivacyPolicy;
